export enum SETTINGS_ROW_ICON_TONE {
  DEFAULT = 'default',
  PRIMARY = 'primary',
}
